import { Container, Grid } from '@material-ui/core'
import dayjs from 'dayjs'
import React, { useContext, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { FormContext, useForm } from 'react-hook-form'
import policyModificationApi from '../../../../api/policyModification.api'
import { PolicyModificationContextStore } from '../../../../context/PolicyModificationContext'
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService'
import { awaitWithLoading, capitalizeFirstLetter } from '../../../../services/utils'
import { ContinueButton } from '../../../Core/Buttons/ContinueButton'
import { RiderDetailsSection } from './RiderDetailsSection'

export const RiderDetailsForm = ({ defaultValues, index, onSave }) => {
  const modifyContext = useContext(PolicyModificationContextStore)
  const form = useForm({ mode: 'onBlur', defaultValues: { ...defaultValues } })
  const [operatorVehicles, setOperatorVehicles] = useState(
    defaultValues.vehicle_ids && defaultValues.vehicle_ids.length > 0
      ? defaultValues.vehicle_ids
      : modifyContext.motorcycles_details.map(x => x.id)
  )

  const saveRiderForm = async data => {
    const rider = modifyContext.rider_details[index]
    if (!data.insured_person_driving_history) {
      data.recent_accident = false
    }
    data.date_of_birth = dayjs(data.date_of_birth).format('YYYY-MM-DD')
    const riderAfterUpdate = {
      ...rider,
      ...data,
      vehicle_ids: operatorVehicles,
      first_name: capitalizeFirstLetter(data.first_name.toLowerCase()),
      last_name: capitalizeFirstLetter(data.last_name.toLowerCase()),
    }
    if (riderAfterUpdate.id === undefined || riderAfterUpdate.is_new == true) {
      var res = await awaitWithLoading(policyModificationApi.getMvrData(riderAfterUpdate, modifyContext.insuranceId))
      if (res.ok) {
        riderAfterUpdate.insured_person_driving_history = res.data.updated_rider.insured_person_driving_history
        riderAfterUpdate.isMvrViolations = res.data.is_new_violations
      }
    }
    const validationResponse = await awaitWithLoading(
      policyModificationApi.validatePolicyRider(riderAfterUpdate, modifyContext.insuranceId)
    )
    if (validationResponse.ok) {
      onSave(riderAfterUpdate, index)
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, validationResponse)
    }
  }

  return (
    <React.Fragment>
      <FormContext {...form}>
        <form autoComplete="off" onSubmit={form.handleSubmit(saveRiderForm)}>
          <Container>
            <RiderDetailsSection operatorVehicles={operatorVehicles} setOperatorVehicles={setOperatorVehicles} />
            <Grid xs={4}>
              <FlexView vAlignContent="center" hAlignContent="left" className="margin-top-large">
                <ContinueButton label="Save" type="submit" />
              </FlexView>
            </Grid>
          </Container>
        </form>
      </FormContext>
    </React.Fragment>
  )
}
